import { QuerySignalsState } from '../../models';

export function getInitialQuerySignalsState(): QuerySignalsState {
  return {
    lastNextQueryLoaded: null,
    nextQueries: [],
    nextQueriesQuery: '',
    relatedTags: []
  };
}
